import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-posting-cell',
  templateUrl: './posting-cell.component.html',
  styleUrls: ['./posting-cell.component.scss']
})
export class PostingCellComponent implements OnInit {
    @Input() posting: any;
    @Input() prepayment = false;

    constructor() { }

    ngOnInit(): void {
    }

    get postingCellClass() {
        return `posting-purpose-${this.posting?.purpose} ${this.posting?.closed ? 'posting-cell-closed' : 'posting-cell-open'}`;
    }

    get postingAmount() {
        if(this.posting?.amount == null) return '-';
        return this.posting?.amount?.toLocaleString('en');
    }
}
